import axios from 'axios'
import { useQuery } from 'react-query'
import { apiGetTestZonesByPlantName } from '../api/test-zones-api'

export const useGetUserTestZones = () => {
  const {
    status,
    data: allTestZones,
    error,
    isLoading,
  } = useQuery(
    ['user-test-zones'],
    async () => {
      const result = await axios.get('/tracer/me/test-zones')
      return result.data.data
    },
    {
      refetchOnWindowFocus: false,
    },
  )
  return { status, allTestZones, isLoading, error }
}

export const usePlantTestZones = ({ plantName }) => {
  const {
    status,
    data: testZones,
    error,
    isLoading,
  } = useQuery(
    ['plant-test-zones', plantName],
    async () => {
      const result = await apiGetTestZonesByPlantName({ plantName })
      return result.data.data
    },
    {
      refetchOnWindowFocus: false,
    },
  )
  return { status, testZones, isLoading, error }
}
